import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../api/services/auth.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UserService } from '../../../api/services/user.service';
import { User } from '../../../api/models/user-model';
import { Team } from '../../../api/models/team';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from '../../delete-modal/delete-modal.component';
import { PreferencesService } from '../../../api/services/preferences.service';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'app-team-edit',
  templateUrl: './team-edit.component.html',
  styleUrls: ['./team-edit.component.scss']
})
export class TeamEditComponent implements OnInit {

  @Input() team: Team;

  @Output() leaveEdit = new EventEmitter<any>();

  teamForm: FormGroup;

  members: User[];

  orgId: string;

  specialSelected: string;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthService,
    private userService: UserService,
    private preferencesService: PreferencesService,
    private modalService: NgbModal
  ) { }

  goBack() {
    this.leaveEdit.emit();
  }

  private onUpdateSuccess() {
    this.toastr.success('Team saved!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateError() {
    this.toastr.error('There was an error saving the team', 'Error!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onDeleteError() {
    this.toastr.error('Error deleting team! ! !', 'Error!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  getType(): string {
    switch (this.team.type) {
      case 0:
      return 'Initiator';
      case 1:
      return 'Approver';
      case 2:
      return 'Contractor';
      default:
      return 'Not defined';
    }
  }

  private onTeamSubscription(team: Team) {

    this.team = team;

    this.userService.findOrganizationById(this.team.organization_id).subscribe(org => {
      this.teamForm = this.formBuilder.group({
        name: [this.team.name, Validators.required],
        description: [this.team.description],
        allowed_pricing: [this.team.allowed_pricing],
        allowed_availability: [this.team.allowed_availability],
        allowed_create_projects: [this.team.allowed_create_projects],
        allowed_create_master_boms: [this.team.allowed_create_master_boms],
        allowed_report_view: [this.team.allowed_report_view],
        organization_id: [this.team.organization_id],
        organization_name: [org.Name]
      });
      this.teamForm.controls.organization_name.disable();
    });

  }

  saveTeam() {
    Object.assign(this.team, this.teamForm.value);
    this.authService.updateTeam(this.team)
      .subscribe(() => {
        this.onUpdateSuccess();
      }, () => {
        this.onUpdateError();
      });
  }

  deleteTeam() {
    const modalRef = this.modalService.open(DeleteModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    //modalRef.componentInstance.id = this.team.id;
    //modalRef.componentInstance.name = this.team.name;
    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the Team <strong>${ this.team.name }</strong> ?`;
    modalRef.componentInstance.fn = () => {
      this.authService.deleteTeam(this.team.id).subscribe(() => {
        modalRef.close();
        this.leaveEdit.emit();
      }, error => {
        modalRef.close();
        this.onDeleteError();
      });
    };
  }

  ngOnInit() {
    this.preferencesService.getPreferences('CUSTOMER', this.team.organization_id).subscribe(prefs => {
      this.specialSelected = prefs['special-fields'].Value;
      this.onTeamSubscription(this.team);
      forkJoin(this.team.user_ids.map(u => this.userService.findUserById(u).pipe(catchError((err) => {return of(undefined)}),)))
        .subscribe((users: User[]) => {
          this.members = users.filter(u => u !== undefined);
        });
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/team-edit/team-edit.component.ts